import PagesWrapper from "../mainpage/PagesWrapper";
import { Section } from "../../../types";
import styles from "./Impressum.module.css";

const Impressum = ({ bgData }: { bgData: Section[] }) => {
  return (
    <PagesWrapper data={bgData} hasTop={false}>
      <div className={styles.header}>IMPRESSUM</div>
      <p>
        Angaben gem&auml;&szlig; &sect; 5 TMG:
        <br />
        Uwe Scheutzel
        <br />
        <br />
        Kontakt:
        <br />
        E-Mail: uwe_s@gmx.de
        <br />
        <p style={{ whiteSpace: "pre" }}>
          Telefon: +49 40 409 601 <br />
          {"             "} +49 162 88 77 825
        </p>
        <br />
        Website erstellt von{" "}
        <a href={"https://skyscribestudios.de"}>Skyscribe Studios</a> <br />
        Lukas Bühner, Benjamin Jens Tränkler GbR
        <br />
        <br />
        Hinweise zur Website
        <br />
        <br />
        Information gem&auml;&szlig; &sect; 36 VSBG
        <br />
        <br />
        Gem&auml;&szlig; &sect; 36 VSBG (Verbraucherstreitbeilegungsgesetz
        &ndash; Gesetz &uuml;ber die alternative Streitbeilegung <br />
        in Verbrauchersachen) erkl&auml;rt der Betreiber dieser Website:
        <br />
        <br />
        Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle <br />
        teilzunehmen.
        <br />
        <br />
        Hinweis
        <br />
        Die Plattform der EU zur au&szlig;ergerichtlichen Streitbeilegung finden
        Sie <br />
        online unter: https://ec.europa.eu/consumers/odr/
      </p>
    </PagesWrapper>
  );
};

export default Impressum;
